import React from "react";

export const Product = ({ name, imageUrl, description }) => {
  return (
    <div className="product-card">
      <div className="product-image">
        <img src={imageUrl} alt={name} />
      </div>
      <div className="product-description">
        <h3>{name}</h3>
         <p dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};
